<template>
  <v-container>

     <v-container class="ma-0 pa-0 d-flex">
      <h1>Пользователи</h1>
      <v-spacer></v-spacer>
      <user-card></user-card>
    </v-container>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="users"
          item-key="_id"
          class="elevation-1"
          :loading="loadingList"
          loading-text="Данные загружаются... Пожалуйста, подождите."
          :search="search"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              placeholder="Введите данные для поиска"
              class="pl-4 pr-4"
              clearable
            ></v-text-field>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | localDatetime }}
          </template>

          <template v-slot:[`item.fullName`]="{ item }">
            {{ item.fullName }}
            <v-badge v-if="!item.isActive" color="red" dot inline></v-badge>
            <partner-cv v-if="Boolean(item.partnerCV)" :partner="item"></partner-cv>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <user-card :id="item._id"></user-card>

            <v-btn 
              icon 
              @click="adminLogin(item._id)"
              :loading="loadingLogin"
            >
              <v-icon>mdi-login</v-icon>
            </v-btn>

            <delete-button
              :id="item._id"
              objName="пользователя"
              :deleteFunc="$store.dispatch"
              funcParam="users/delete"
            >
              Имя: {{ item.fullName }} <br>
              Email: {{ item.email }}
            </delete-button>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserCard from "../components/users/UserCard";
import PartnerCv from '../components/users/PartnerCv';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    UserCard,
    PartnerCv
  },

  data() {
    return {
      search: "",
      loadingLogin: false,
      tableHeaders: [
        {
          text: "Дата регистрации",
          value: "createdAt"
        },
        {
          text: "Имя",
          value: "fullName"
        },
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Роль",
          value: "roleText"
        },
        {
          text: 'Город',
          value: 'partnerCV.city'
        },
        {
          text: "Действия",
          value: "actions",
          sortable: false
        }
      ]
    };
  },

  created() {
    document.title = "Пользователи";
    this.$store.dispatch('users/loadList');
    this.$store.dispatch('sites/loadList');
  },

  methods: {
    async adminLogin(userId) {
      try {
        this.loadingLogin = true;
        await this.$store.dispatch('users/adminAuth', userId);
        this.$router.push('/dashboard');
      } catch(err) {
        this.$store.dispatch('showMessage', err.message);
      } finally {
        this.loadingLogin = false;
      }
    },
  },

  computed: {
    ...mapGetters('users', ['loadingList']),
    ...mapState('users', ['users'])
  }
};
</script>